import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import classes from '../../EmailPreview/InServiceRecap/InServiceRecap.module.css';
import emailPreviewClasses from '../../EmailPreview/EmailPreview.module.css';
import customizeEmailClasses from '../CustomizeEmail.module.css';
import { Modal } from 'reactstrap';

import Footer from '../../Shared/Footer/Footer';
import LogoPreview from '../../Shared/LogoPreview/LogoPreview';
import ReactEasyCrop from '../../../../../Components/ReactEasyCrop/ReactEasyCrop';
import CloseModalButton from '../../../../../Components/CloseModalButton/CloseModalButton';

import { postTemplateImagesToEngagementEmailAction } from '../../../../../Store/actions/trials/engagementEmailsAction';
import { useDispatch, useSelector } from 'react-redux';

import Toggle from 'react-toggle'

import handleToggleChange from './handleToggleChange';
import resetInputFileValue from '../../../../../Utils/resetInputFileValue';

const InServiceRecapCommunications = ({ inputs, handleInputChange, formValidationErrors }) => {
    const dispatch = useDispatch();
    const { id, engagementEmailID } = useParams();

    const [ isImageEditingOpen, setIsImageEditingOpen ] = useState(false);
    const toggleIsImageEditingOpen = () => setIsImageEditingOpen(previousIsImageEditingOpen => !previousIsImageEditingOpen);

    const [ uploadedImage, setUploadedImage ] = useState(null);

    const handleImageEditing = (event) => {
        let imageFile = event.target.files[ 0 ];
        setIsImageEditingOpen(true);
        let imageDimensions = {
            height: 136,
            width: 233
        };

        if (event.target.name === 'facility_logo')
        {
            imageDimensions = {
                height: 92,
                width: 460
            }
        }

        setUploadedImage({
            name: event.target.name,
            dimensions: imageDimensions,
            file: URL.createObjectURL(imageFile)
        });
    }

    const handleImageUpload = (imageObject) => {
        let formData = new FormData();
        formData.append('template_id', engagementEmailID);
        formData.append('trial_id', id);
        formData.append('user_id', localStorage.getItem('user_id'));

        if (imageObject.name === 'facility_image')
        {
            formData.append('facility_image', imageObject.file);
            formData.append('facility_logo', inputs.facility_logo);
        } else if (imageObject.name === 'facility_logo')
        {
            formData.append('facility_image', inputs.facility_image);
            formData.append('facility_logo', imageObject.file);
        }

        dispatch(postTemplateImagesToEngagementEmailAction(formData));
    }

    const BASE_URL = process.env.REACT_APP_API_URL;

    let facilityImage = BASE_URL + inputs.facility_image;
    let facilityLogo = BASE_URL + inputs.facility_logo;

    if (inputs.facility_image === "")
    {
        facilityImage = '/images/email/facility-image-placeholder.png';
    }

    if (inputs.facility_logo === "")
    {
        facilityLogo = '/images/email/facility-logo-placeholder.png';
    }

    const postTemplateImagesEngagementEmailError = useSelector(state => state.engagementEmails.postTemplateImagesEngagementEmailError);

    const handleInputNumberChange = (event) => {
        if (event.target.value.length > 3) return;
        handleInputChange(event);
    }

    const handleAttendeesLineOneKeyUp = (event) => {
        if (event.keyCode === 13)
        {
            let attendeesTextArray = event.target.value.replaceAll('&bull;', '').replaceAll(String.fromCharCode(8226), '').split('\n');
            attendeesTextArray = attendeesTextArray.map((text, index) => {
                if (index + 1 === attendeesTextArray.length) return String.fromCharCode(8226) + text;
                return String.fromCharCode(8226) + text + '\n';
            });

            handleInputChange({
                target: {
                    name: event.target.name,
                    value: attendeesTextArray.join("")
                }
            });
        }
    }

    return (
        <div className="customize-email__preview-wrapper">
            <LogoPreview />
            <div className={ classes[ "header" ] }>
                <div className={ classes[ "header__left" ] }>
                    <div className={ classes[ "header__image-container" ] }>
                        <label htmlFor="facility_image">
                            <img
                                className={ [ classes[ "header__image" ], "cursor" ].join(" ") }
                                src={ facilityImage }
                                alt="facility image" />
                        </label>

                        <input
                            onChange={ handleImageEditing }
                            onClick={ resetInputFileValue }
                            className="hidden"
                            type="file"
                            accept="image/png, image/jpeg"
                            name="facility_image"
                            id="facility_image" />
                    </div>
                    <div className={ classes[ "header__image-container" ] }>
                        <label htmlFor="facility_logo">
                            <img
                                className={ [ classes[ "header__image" ], "cursor" ].join(" ") }
                                src={ facilityLogo }
                                alt="facility logo" />
                        </label>

                        <input
                            onChange={ handleImageEditing }
                            onClick={ resetInputFileValue }
                            className="hidden"
                            type="file"
                            accept="image/png, image/jpeg"
                            name="facility_logo"
                            id="facility_logo" />
                    </div>
                </div>

                <div className={ classes[ "header__right" ] }>
                    <div className={ classes[ "header__heading" ] }>
                        <div className={ classes[ "header__text-light" ] }>
                            <label htmlFor="title" className="hidden">
                                title
                            </label>
                            <textarea
                                onChange={ handleInputChange }
                                value={ inputs.title || '' }
                                className="w-100 mb-2 d-block"
                                name="title"
                                id="title"></textarea>

                            { formValidationErrors?.title ? (
                                <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.title }</span>
                            ) : (null) }
                        </div>
                        <div className={ emailPreviewClasses[ "header__text-bold" ] }>
                            <label htmlFor="sub_title" className="hidden">
                                sub title
                            </label>
                            <textarea
                                onChange={ handleInputChange }
                                value={ inputs.sub_title || '' }
                                type="text"
                                className="w-100 mb-2 d-block"
                                name="sub_title"
                                id="sub_title"></textarea>

                            { formValidationErrors?.sub_title ? (
                                <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.sub_title }</span>
                            ) : (null) }
                        </div>
                    </div>

                    <div className={ emailPreviewClasses[ "ribbon" ] }></div>

                    <div className={ classes[ "header__description" ] }>
                        <label htmlFor="title_description" className="hidden">
                            title description
                        </label>
                        <textarea
                            onChange={ handleInputChange }
                            value={ inputs.title_description || '' }
                            className="w-100 mb-2"
                            name="title_description"
                            id="title_description"
                            rows="5"
                        ></textarea>

                        { formValidationErrors?.title_description ? (
                            <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.title_description }</span>
                        ) : (null) }
                    </div>
                </div>
            </div>

            <div className={ classes[ "paragraphs-container" ] }>
                <div className={ emailPreviewClasses[ "email-preview__paragraph" ] }>
                    <label htmlFor="recipient_name" className="hidden">
                        recipient name
                    </label>
                    <input
                        onChange={ handleInputChange }
                        value={ inputs.recipient_name || '' }
                        type="text"
                        name="recipient_name"
                        id="recipient_name"
                        className={ [ "light-text", "w-100", "mb-2" ].join(" ") } />

                    { formValidationErrors?.recipient_name ? (
                        <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.recipient_name }</span>
                    ) : (null) }
                </div>

                <div className={ emailPreviewClasses[ "email-preview__paragraph" ] }>
                    <label htmlFor="content" className="hidden">
                        content
                    </label>
                    <textarea
                        onChange={ handleInputChange }
                        value={ inputs.content || '' }
                        name="content"
                        id="content"
                        className="customize-email__content-textarea"
                        rows="15"></textarea>

                    { formValidationErrors?.content ? (
                        <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.content }</span>
                    ) : (null) }
                </div>
            </div>

            <div className={ [ classes[ "section" ], "pb-0" ].join(" ") }>
                <div className="flex-shrink-0">
                    <img
                        className={ classes[ "section__image" ] }
                        src="/images/email/recap-11.png"
                        alt="workstation" />
                </div>

                <div className={ classes[ "section__item" ] }>
                    <div className={ classes[ "section__number" ] }>
                        <label htmlFor="inservice_attendees_number" className="hidden">
                            inservice attendees number
                        </label>
                        <input
                            onChange={ handleInputNumberChange }
                            value={ inputs.inservice_attendees_number || '' }
                            type="number"
                            className={ [ "light-text", "w-100", "mb-2" ].join(" ") }
                            name="inservice_attendees_number"
                            id="inservice_attendees_number" />

                        { formValidationErrors?.inservice_attendees_number ? (
                            <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.inservice_attendees_number }</span>
                        ) : (null) }
                    </div>
                    <div className={ classes[ "section__text-light" ] }>
                        <label htmlFor="inservice_attendees_title" className="hidden">
                            inservice attendees title
                        </label>
                        <input
                            onChange={ handleInputChange }
                            value={ inputs.inservice_attendees_title || '' }
                            type="text"
                            className="w-100 mb-2"
                            name="inservice_attendees_title"
                            id="inservice_attendees_title" />

                        { formValidationErrors?.inservice_attendees_title ? (
                            <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.inservice_attendees_title }</span>
                        ) : (null) }
                    </div>
                    <div className={ classes[ "section__text-bold" ] }>
                        <label htmlFor="inservice_attendees_subtitle" className="hidden">
                            inservice attendees sub title
                        </label>
                        <input
                            onChange={ handleInputChange }
                            value={ inputs.inservice_attendees_subtitle || '' }
                            type="text"
                            className="w-100 mb-2"
                            name="inservice_attendees_subtitle"
                            id="inservice_attendees_subtitle" />

                        { formValidationErrors?.inservice_attendees_subtitle ? (
                            <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.inservice_attendees_subtitle }</span>
                        ) : (null) }
                    </div>

                    <div className={ emailPreviewClasses[ "ribbon" ] }></div>

                    <div className={ classes[ "tutorial" ] }>
                        <div className={ classes[ "tutorial__text" ] }>
                            Tutorials:
                        </div>

                        <div className={ classes[ "tutorial__list" ] }>
                            <label htmlFor="inservice_attendees_line1" className="hidden">
                                inservice attendees line one
                            </label>
                            <textarea
                                onChange={ handleInputChange }
                                onKeyUp={ handleAttendeesLineOneKeyUp }
                                value={ inputs.inservice_attendees_line1 || '' }
                                name="inservice_attendees_line1"
                                id="inservice_attendees_line1"
                                className="w-100 mb-2"
                                rows="5"></textarea>

                            { formValidationErrors?.inservice_attendees_line1 ? (
                                <span className={ customizeEmailClasses[ "input__error" ] }>{ formValidationErrors?.inservice_attendees_line1 }</span>
                            ) : (null) }
                        </div>
                    </div>
                </div>
                { inputs.inservice_attendees_is_on === "0" ? (
                    <div className={ customizeEmailClasses[ "overlay" ] }></div>
                ) : (null) }
            </div>
            <div className={ customizeEmailClasses[ "toggle-container" ] }>
                <label htmlFor="inservice_attendees_is_on" className="hidden">
                    inservice attendees is on
                </label>
                <Toggle
                    onChange={ event => handleToggleChange({ event, handleInputChange }) }
                    checked={ inputs.inservice_attendees_is_on === "1" }
                    className="toggle-yellow"
                    icons={ true }
                    name="inservice_attendees_is_on"
                    id="inservice_attendees_is_on" />
            </div>
            <Footer text={ inputs.footer } />

            <Modal
                isOpen={ isImageEditingOpen }
                toggle={ toggleIsImageEditingOpen }
                centered
                backdrop="static">
                <CloseModalButton onClick={ toggleIsImageEditingOpen } />

                <ReactEasyCrop
                    image={ uploadedImage }
                    toggleIsImageEditingOpen={ toggleIsImageEditingOpen }
                    onSuccessCallback={ handleImageUpload } />
            </Modal>
        </div>
    );
}

export default InServiceRecapCommunications;